export default "__VITE_ASSET__b7e7c493__"